import { AbstractControl, ValidationErrors } from "@angular/forms";
import { CustomValidator } from "experian-design-system";

export class EmailDomainValidator extends CustomValidator {
  private readonly regex: RegExp;

  constructor(regex: RegExp) {
    super();
    this.regex = regex;
  }

  protected isValid(control: AbstractControl): boolean {
    if (this.regex.test(control.value)) {
      return true;
    }

    return false;
  }

  protected errorValidator(): ValidationErrors {
    return {
      emailDomain: "Insira um endereço de e-mail válido. Ex. joao@empresa.com",
    };
  }
}
